import TabWithProductTable from "../../Common/TabWithProductTable";

export const CohortsTab = () => <TabWithProductTable />;
